<div *ngFor="let toast of toasts" class="{{ cssClass(toast) }}" (click)="emitLinkClicked(toast)" [ngClass]="{'pointer' : toast.link}">
  <a *ngIf="!toast.transient" class="close" (click)="removeToast(toast)"><bw-icon-legacy iconName="close" size="24" [color]="toast.type === 2 ? 'var(--primary-text)' : 'var(--white)'"></bw-icon-legacy></a>
  <div class="flex-row toast-message">
    <span
      *ngIf="toast.type === ToastType.Success"
      class="material-symbols-outlined toast-success-icon"
      aria-hidden="true"
    >check_circle</span>
    <div class="mr-xs">{{ toast.message }}</div>
    <bw-icon-legacy *ngIf="toast.link" iconName="chevron_right" size="24" [color]="toast.type === 2 ? 'var(--primary-text)' : 'var(--white)'"></bw-icon-legacy>
  </div>
</div>
